import {makeStyles, createStyles, Theme} from "@material-ui/core/styles"
import { PRIMARY_COLOR } from "~/constants/colors"

export default makeStyles((theme: Theme) => createStyles({
  titleBlock: {
    color: PRIMARY_COLOR.Primary1,
    marginBottom: 64,
    [theme.breakpoints.down('xs')]: {
      marginBottom: 40
    }
  },
  title: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  slider: {
    marginBottom: 128,
    [theme.breakpoints.down('xs')]: {
      marginBottom: 80
    }
  }
}));
